import React from "react";
import Solution from "./components/Solution";

const Problem3 = () => {
  return (
    <div className="p-4">
      <h1 className="">Problem 3</h1>
      <p className="">
        <div className="">Create a date picker component.</div>
      </p>
      <Solution />
    </div>
  );
};

export default Problem3;
